// extracted by mini-css-extract-plugin
module.exports = {"root":"Header-module--root--1mpSA","wrapper":"Header-module--wrapper--3rZRj","title":"Header-module--title--3JWMg","light":"Header-module--light--3IvZq"};